module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_02_6DD79_1SE_HZK.189aaae5.jpg";